<script context="module" lang="ts">
  // Update type with each new component
  export type ButtonComponent =
    | typeof DefaultButton
    | typeof OoniqueButton
    | typeof MybacsButton
    | typeof ThisPlaceButton;
</script>

<script lang="ts">
  import type { EventDispatcher } from "svelte";
  import {
    capturePHComponentDisplayEvent,
    capturePHComponentInViewportEvent,
    capturePHEvent,
  } from "../../lib/posthog";
  import { getLocalizedProp } from "../../utils";
  import { modalOpen } from "../store";
  import type { ShopComponentProps } from "../types";
  import DefaultButton from "./variants/DefaultButton.svelte";
  import MybacsButton from "./variants/MybacsButton.svelte";
  import OoniqueButton from "./variants/OoniqueButton.svelte";
  import ThisPlaceButton from "./variants/ThisPlaceButton.svelte";

  export let componentProps: ShopComponentProps;
  export let dispatch: EventDispatcher<any>;
  export let Component: ButtonComponent;
  export let updateFootprint: () => void;

  componentProps.updateFootprint();

  let button: HTMLDivElement;
  $: if (button) {
    capturePHComponentDisplayEvent(button, "button_displayed", {
      footprintPrice: componentProps.price,
    });
    capturePHComponentInViewportEvent(button, "button_in_viewport", {
      footprintPrice: componentProps.price,
    });
  }

  const modalCallback = () => {
    modalOpen.set(true);
    capturePHEvent("modal_opened_by_button");
  };

  const locale: string = document.documentElement.lang;
</script>

<div class="pina-app-button-adapter" bind:this={button}>
  <svelte:component
    this={Component}
    {dispatch}
    {...componentProps}
    header={getLocalizedProp(componentProps.header, locale)}
    modalText={getLocalizedProp(componentProps.modalText, locale)}
    text={getLocalizedProp(componentProps.text, locale)}
    moreInfo={getLocalizedProp(componentProps.moreInfo, locale)}
    {modalCallback}
  />
</div>
